import { render, staticRenderFns } from "./ShareToCommunity.vue?vue&type=template&id=be6aed5c&scoped=true&"
import script from "./ShareToCommunity.vue?vue&type=script&lang=js&"
export * from "./ShareToCommunity.vue?vue&type=script&lang=js&"
import style0 from "./ShareToCommunity.vue?vue&type=style&index=0&id=be6aed5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6aed5c",
  null
  
)

export default component.exports